// Banks print names in all capitals, and some records arrive all lower case. Neither says how the
// name is really written, so both read as ordinary capitals. A name already in mixed case was
// written that way on purpose and is left alone. This is for display only: the stored value and
// the edit box keep what was read.
const JOINING_WORDS = new Set(['and', 'or', 'of', 'the', 'for'])

const WORD_START = /(^|[\s\-'’(/&.])(\p{L})/gu

const hasOneCase = (text: string) =>
  text === text.toUpperCase() || text === text.toLowerCase()

const capitalise = (word: string, position: number) =>
  position > 0 && JOINING_WORDS.has(word)
    ? word
    : word.replace(
        WORD_START,
        (_match, before, letter) => before + letter.toUpperCase(),
      )

export const readableName = (text: string) =>
  hasOneCase(text)
    ? text
        .toLowerCase()
        .split(' ')
        .map((word, position) => capitalise(word, position))
        .join(' ')
    : text
